var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessageSentIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 50,
    viewBox: "0 0 58 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_159_2625)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.7609 23.9194C30.3392 23.9194 31.6186 22.6312 31.6186 21.0422C31.6186 19.4532 30.3392 18.165 28.7609 18.165C27.1827 18.165 25.9033 19.4532 25.9033 21.0422C25.9033 22.6312 27.1827 23.9194 28.7609 23.9194Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9753 23.9194C18.5535 23.9194 19.8329 22.6312 19.8329 21.0422C19.8329 19.4532 18.5535 18.165 16.9753 18.165C15.3971 18.165 14.1177 19.4532 14.1177 21.0422C14.1177 22.6312 15.3971 23.9194 16.9753 23.9194Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5612 18.165C38.9831 18.165 37.7036 19.4533 37.7036 21.0422C37.7036 22.6311 38.9831 23.9194 40.5612 23.9194C42.1393 23.9194 43.4189 22.6311 43.4189 21.0422C43.4189 19.4533 42.1393 18.165 40.5612 18.165Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5576 49.7996L35.045 42.0985H48.4232C53.4561 42.0985 57.5363 37.976 57.5363 32.923V9.17549C57.5363 4.12253 53.4418 0 48.4232 0H9.11312C4.09451 0 0 4.12253 0 9.17549V32.923C0 37.9903 4.09451 42.0985 9.11312 42.0985H21.6099V48.7547C21.6099 49.227 21.8658 49.6421 22.2781 49.8712C22.6762 50.0859 23.1738 50.0716 23.5576 49.8139V49.7996ZM9.11312 39.5792C5.47356 39.5792 2.5022 36.6018 2.5022 32.923V9.17549C2.5022 5.51102 5.47356 2.51932 9.11312 2.51932H48.409C52.0486 2.51932 55.0199 5.49671 55.0199 9.17549V32.923C55.0199 36.5875 52.0628 39.5792 48.409 39.5792H34.6611C34.3768 39.5792 34.1351 39.6221 33.9361 39.7366L24.1263 46.3928V40.8388C24.1263 40.1374 23.5576 39.5792 22.8752 39.5792H9.11312Z",
    fill: "#FF0000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_159_2625"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57.5221,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageSentIcon);
export default __webpack_public_path__ + "static/media/messageSentIcon.dd2a680ec31d62618bf60b972daa442b.svg";
export { ForwardRef as ReactComponent };